import React from 'react';
import { Link, useNavigate} from 'react-router-dom';
import './Careers.scss';


const Careers = () => {
  const navigate = useNavigate();
  
  return (
    <div className="careers-page">
      <section className="careers-hero">
        <div className="container">
          <h1>Join Our Amazing Team</h1>
          <p className="hero-text">
            Build your career with us and be part of a team that's transforming businesses through innovative technology solutions. We offer exciting opportunities for growth, learning, and making a real impact.
          </p>
          {/* <div className="team-info">
            <p><strong>50+ Team Members</strong></p>
            <p>Tech City Office</p>
          </div> */}
        </div>
      </section>

      {/* <section className="why-work-with-us">
        <div className="container">
          <h2>Why Work With Us?</h2>
          <p className="section-intro">
            We believe in creating an environment where talented individuals can thrive, grow, and make meaningful contributions
          </p>

          <div className="benefits-grid">
            <div className="benefit-card">
              <h3>Competitive Compensation</h3>
              <p>Market-competitive salaries and performance-based bonuses</p>
            </div>
            <div className="benefit-card">
              <h3>Health & Wellness</h3>
              <p>Comprehensive health insurance and wellness programs</p>
            </div>
            <div className="benefit-card">
              <h3>Professional Growth</h3>
              <p>Training opportunities, certifications, and career development</p>
            </div>
            <div className="benefit-card">
              <h3>Work-Life Balance</h3>
              <p>Flexible schedules, remote work options, and generous PTO</p>
            </div>
            <div className="benefit-card">
              <h3>Innovation Culture</h3>
              <p>Work on cutting-edge projects with the latest technologies</p>
            </div>
            <div className="benefit-card">
              <h3>Team Environment</h3>
              <p>Collaborative culture with supportive and talented colleagues</p>
            </div>
          </div>
        </div>
      </section> */}

      <section className="job-openings">
        <div className="container">
          <h2>Current Job Openings</h2>
          <p className="section-intro">Find your next career opportunity with us</p>

          {/* <div className="job-search">
            <input type="text" placeholder="Search jobs..." />
          </div> */}

          <div className="job-listings">
            <div className="job-card">
              <h3>QGIS Executive</h3>
              {/* <div className="job-meta">
                <span className="location">Tech City, TC</span>
                <span className="employment-type">Full-time</span>
                <span className="salary">$80,000 - $120,000</span>
              </div> */}
              <p className="job-description">
                We are seeking an experienced QGIS developer to lead our geographic information systems projects and mentor junior developers.
              </p>
              <div className="job-details">
                <div className="requirements">
                  <h4>Requirements</h4>
                  <ul>
                    <li>Basic to advanced knowledge of QGIS development and customization</li>
                    <li>Knowledge of map creation, spatial analysis, and data visualization</li>
                    <li>Understanding of QGis/ArcGis is a plus</li>
                    <li>Freshers and experienced candidates both can apply</li>
                    <li>Educational Qualification: B.Sc, M.Sc (Geography or related fields), BCA, MCA</li>
                  </ul>
                </div>
                {/* <div className="benefits">
                  <h4>Benefits</h4>
                  <div className="benefits-grid">
                    <span>Health Insurance</span>
                    <span>Retirement plan</span>
                    <span>Flexible hours</span>
                    <span>Professional development</span>
                  </div>
                </div> */}
              </div>
              <div className="job-actions">
                <Link to="/contact" className="btn-apply">Apply Now</Link>
              </div>
            </div>

            <div className="job-card">
              <h3>IT Solutions Developer</h3>
              <p className="job-description">
                Join our IT team as a Solutions Architect to design and implement comprehensive technology solutions for our clients.
              </p>
              <div className="job-details">
                <div className="requirements">
                  <h4>Requirements</h4>
                  <ul>
                   <li>Understanding of system development and desing</li>
                    <li>Basic knowledge of cloud platforms (AWS, Azure)</li>
                    <li>General knowledge of network infrastructure</li>
                    <li>Freshers and experienced professionals both can apply</li>
                    <li>Educational Qualification: BCA, MCA, B.Tech, M.Tech, or related IT degrees</li>
                  </ul>
                </div>
              </div>
              <div className="job-actions">
                <Link to="/contact" className="btn-apply">Apply Now</Link>
              </div>
            </div>

            <div className="job-card">
              <h3>Document Management Operator</h3>
              <p className="job-description">
                Help organizations transform their document workflows through our innovative document management systems.
              </p>
              <div className="job-details">
                <div className="requirements">
                  <h4>Requirements</h4>
                  <ul>
                    <li>Understanding of document management systems</li>
                    <li>Ability to handle documentation operations efficiently</li>
                    <li>Freshers are encouraged to apply</li>
                    <li>Educational Qualification: BCA, MCA, or related fields</li>
                  </ul>
                </div>
              </div>
              <div className="job-actions">
                <Link to="/contact" className="btn-apply">Apply Now</Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="application-process">
        <div className="container">
          <h2>Application Process</h2>
          <p className="section-intro">
            Our streamlined hiring process ensures a great experience for all candidates
          </p>

          <div className="process-steps">
            <div className="process-step">
              <h3>Apply Online</h3>
              <p>Submit your application and resume through our portal</p>
            </div>
            <div className="process-step">
              <h3>Initial Review</h3>
              <p>Our team reviews your qualifications and experience</p>
            </div>
            <div className="process-step">
              <h3>Interview</h3>
              <p>Meet with our team to discuss your fit for the role</p>
            </div>
            <div className="process-step">
              <h3>Decision</h3>
              <p>Receive feedback and next steps within one week</p>
            </div>
          </div>
        </div>
      </section>

      <section className="general-application">
        <div className="container">
          <h2>Ready to Start Your Journey?</h2>
          <p className="section-intro">
            Don't see the perfect position? Send us your resume and we'll keep you in mind for future opportunities.
          </p>
          <button onClick={() => navigate('/contact')} className="btn-submit-application">Submit General Application</button>
        </div>
      </section>
    </div>
  );
};

export default Careers;